import {observable, action} from 'mobx';

export class EndMeetingModalController {
    @observable isVisible = false;
    private _resolve?: (val: boolean) => void;

    @action
    open = (): Promise<boolean> => {
        this.isVisible = true;

        return new Promise((resolve) => {
            this._resolve = resolve;
        });
    };
    @action
    confirm = () => {
        this.isVisible = false;
        this._resolve?.(true);
    };

    @action
    cancel = () => {
        this.isVisible = false;
        this._resolve?.(false);
    };

    @action
    onHideHandler = () => {
        this.cancel();
    };

    @action
    dispose = () => {
        this.isVisible = false;
        this._resolve = undefined;
    };
}
